<div class="grid-container">
  <div class="grid-x">
    <div class="cell large-6 medium-6 small-6 bold">
      Comments:
    </div>
    <div class="cell large-6 medium-6 small-6">
      <span class="padding-right">
        @if (editorOpen) {
          <button class="button" (click)="editorOpen = !editorOpen">Hide Editor</button>
        }
        @if (!editorOpen) {
          <button class="button" (click)="editorOpen = !editorOpen">Show Editor</button>
        }
      </span>
      @if (notesSaving === false) {
        <span>
          @if (editorOpen) {
            <button class="button" (click)="addComment()" [disabled]="notesForm?.invalid">Add</button>
          }
        </span>
      } @else {
        <span>
          <text-loader [text]="'Saving Note'" [tickType]="'.'" [interval]="2000" [run]="true" [cycleLimit]="5"></text-loader>
        </span>
      }

    </div>
    @if (editorOpen) {
      <div class="cell large-12 medium-12 small-12">
        <text-editor (formBuilt)="notesFormBuilt($event)" [froalaOptions]="editorOptions"></text-editor>
      </div>
    }
    @if (notes?.length > 0) {
      @for (item of notes; track item; let isLast = $last) {
        <div class="cell large-12 medium-12 small-12 margin-top">
          <display-note [note]="item"></display-note>
        </div>
      }
    } @else {
      <div class="cell large-12 medium-12 small-12 margin-top">
        <p>No recorded notes.</p>
      </div>
    }
  </div>

</div>






